(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/fallback.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/fallback.js');

'use strict';

const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const _svs$iam_idp$atoms = svs.iam_idp.atoms,
  activeMethodAtom = _svs$iam_idp$atoms.activeMethodAtom,
  showFallbackQrAtom = _svs$iam_idp$atoms.showFallbackQrAtom,
  showLoaderAtom = _svs$iam_idp$atoms.showLoaderAtom,
  showFallbackAtom = _svs$iam_idp$atoms.showFallbackAtom;
const Button = svs.ui.Button;
const isPnp = svs.iam_idp.data.isPnp;
const Fallback = () => {
  const setShowFallbackQr = useSetAtom(showFallbackQrAtom);
  const setShowLoader = useSetAtom(showLoaderAtom);
  const setShowFallback = useSetAtom(showFallbackAtom);
  const activeMethod = useAtomValue(activeMethodAtom);
  const handleClick = () => {
    setShowLoader(true);
    setShowFallback(false);
    setShowFallbackQr(true);
  };
  return React.createElement("div", {
    className: "margin-xs-top-2 fade-in align-center"
  }, React.createElement("div", null, React.createElement("p", null, "F\xF6rs\xF6ker starta", ' ', activeMethod.methodName, "-appen"), React.createElement(Button, {
    block: true,
    className: "margin-top-4 margin-bottom-1",
    iconPosition: "left",
    inverted: isPnp,
    onClick: handleClick,
    size: 300,
    transparent: true
  }, "Logga in p\xE5 annan enhet")));
};
svs.iam_idp.components.shared.Fallback = Fallback;

 })(window);